import { isNonEmpty } from '@sgme/fp';
import { emailServiceApiConnector } from 'apiConnector/email-service';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { emailServiceFormSubmissionFailed, emailServiceFormSubmitted } from 'state/emailService/emailService.actions';
import type { EpicWithThunk } from 'state/state.common';

export function emailServiceSubmitFormEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('EMAIL_SERVICE_FORM_SUBMISSION_REQUESTED'),
      mergeMap(({ tradeId, request }) =>
        emailServiceApiConnector(httpClient)
          .submit(tradeId, request)
          .pipe(
            mergeMap(({ warnings, errors }) => {
              if (isNonEmpty(errors)) {
                return of(
                  emailServiceFormSubmissionFailed([
                    'emailService.status.message.error.404.or.known.errors',
                    ...errors,
                  ]),
                );
              } else {
                return of(
                  emailServiceFormSubmitted(
                    isNonEmpty(warnings) ? ['emailService.status.message.sentWithWarnings', ...warnings] : [],
                  ),
                );
              }
            }),
            catchError(error => {
              if (error?.status === 403) {
                return of(emailServiceFormSubmissionFailed(['emailService.status.message.error.403']));
              }

              if (error?.status === 404) {
                return of(emailServiceFormSubmissionFailed(['emailService.status.message.error.404.or.known.errors']));
              }

              return of(emailServiceFormSubmissionFailed(['emailService.status.message.error.500.or.others']));
            }),
          ),
      ),
    );
}
